module.exports = __webpack_public_path__ + "static/media/fa-regular-400.291b9191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-regular-400.svg
// module id = 740
// module chunks = 0